import React from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";
import { selectComponents } from "../../../../core/data/redux/projects/selectors";
import type { Component } from "../../../../core/data/redux/projects/types";

interface ComponentPickerProps {
  value: number | null | undefined;
  onChange: (componentId: number | null) => void;
  size?: "small" | "middle" | "large";
  disabled?: boolean;
}

const ComponentPicker: React.FC<ComponentPickerProps> = ({
  value,
  onChange,
  size = "middle",
  disabled,
}) => {
  const components = useSelector(selectComponents);

  return (
    <Select
      allowClear
      style={{ height: 36 }}
      size={size}
      className="w-100"
      placeholder="Select component"
      value={value ?? undefined}
      onChange={(v) => onChange(v ?? null)}
      disabled={disabled}
      options={components.map((c: Component) => ({
        value: c.id,
        label: c.name,
      }))}
    />
  );
};

export default ComponentPicker;
